
import React, { FC } from 'react';

import styled from 'styled-components';
import Icon from '../Icon';

import { Link } from 'components/Common';

interface SectionHeaderProps {
  id?: string;
  titleText: string;
  linkText?: string;
  link?: string;
  icon?: any;
}

const Header = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;

  padding: 0px 16px 8px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColorV2};
`;

const Title = styled.span`
  flex: 1;
  color: ${({ theme }) => theme.fitbitGray};
`;

const LinkContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  gap: 10px;

  color: ${({ theme }) => theme.fitbitGreenV2};

  background: ${({ theme }) => theme.fitbitLightGray};
  border-radius: 12px;

`;

const SectionHeader: FC<SectionHeaderProps> = ({
  id,
  titleText,
  linkText,
  link,
  icon
}) => (
  <Header>
    <Title>
      {titleText}
    </Title>
    { link && (
      <LinkContainer
        id={id}
        aria-label={id}
        to={link}
        pageDirection='FORWARD'
      >
        <Icon
          id={`edit-icon-${id}`}
          aria-label={`edit-icon-${id}`}
          url={icon}
          width={13}
          height={13}
        />
        {linkText}
      </LinkContainer>
    )}
  </Header>
);

export default SectionHeader;
